/**
 * Helpers for the "Exclude providers" view filter.
 * Exclusions are view-only: they hide a provider's row and remove it from the
 * totals/export, but never change stored or cross-report totals.
 */
export const providerKey = (row) => {
    if (!row) return '';
    const id = row.doctorId ?? row.ABBR ?? row.doctorName ?? row.doctorNameFromProvider;
    return id === undefined || id === null ? '' : String(id).toLowerCase();
};

export const providerLabel = (row) =>
    row?.doctorName || row?.doctorNameFromProvider || row?.ABBR || 'Unknown provider';

export const removeExcludedProviders = (rows, excludedProviders) => {
    if (!excludedProviders || excludedProviders.length === 0) return rows;
    const keys = new Set(excludedProviders.map(p => p.key));
    return (rows || []).filter(row => !keys.has(providerKey(row)));
};
